<button id="openModalButton" (click)="showSuccess = true" hidden></button>

<ds-modal [modalInput]="modalConfig"
       (confirmed)="onLoginClick()">
       <div class="modal-content-wrapper" modal-body>
              <div class="modal-child-content">
                     <p>{{"register_as_text" | translate }} <br>
                     "<span id="email-text" class="text-warning">{{email}}</span>"
                     </p>
              </div>
              <p>{{"the_domain" | translate}} <b>{{domainName}}</b> {{"domain_already_registered" | translate}}</p>
              <div class="primary-info-section">
                     <ds-info-text [infoTextInput]="invitationInfoConfig">
                            <p><a href="javascript:void(0)" (click)="SendInviteeNotificationToFinanceManager()">{{"click_here" | translate}}</a> {{"request_invitation_from_admin" | translate}}</p>
                     </ds-info-text>
                     <ds-info-text [infoTextInput]="loginInfoConfig">
                            <p>{{"already_have_invitation" | translate}} <a href="javascript:void(0)" (click)="onLoginClick()">{{"click_here" | translate}}</a> {{"to_login" | translate}}</p>
                     </ds-info-text>
              </div>
       </div>
       <div modal-footer>
              <ds-button
                     [buttonInput]="continueConfig"
                     (btnClick)="onLoginClick()">
              </ds-button>
       </div>
</ds-modal>

